module.exports = __webpack_public_path__ + "static/img/xxyj_banner.b677e56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xxyj_banner.png
// module id = MUvC
// module chunks = 21